import styles from "./Heart.module.css";
import PropTypes from "prop-types";
import { useFreshState } from "shared/hooks/useFreshState";
import { IconHeartFilled } from "./IconHeartFilled";
import { IconHeartEmpty } from "./IconHeartEmpty";

/**
 * Another checkbox style.
 *
 * Displays a heart icon that can be filled or hollow.
 * Indicates whether the customer who received the sample
 * was satisfied.
 */
export function Heart({ id, isChecked, onChange }) {
  const [checked, setChecked] = useFreshState(isChecked);

  return (
    <div className={styles.heart}>
      <input
        id={id}
        type="checkbox"
        style={{ display: "none" }}
        checked={checked}
        onClick={(e) => {
          e.preventDefault();
          setChecked(!checked);
          if (onChange) onChange(!checked, e);
        }}
        onChange={() => {}}
      />
      <label className={styles.label} htmlFor={id}>
        {checked ? (
          <IconHeartFilled width={18} height={18} />
        ) : (
          <IconHeartEmpty width={18} height={18} />
        )}
      </label>
    </div>
  );
}

Heart.propTypes = {
  /**
   * ID string for checkbox element.
   */
  id: PropTypes.string.isRequired,

  /**
   * Displays filled if true, hollow if false.
   */
  isChecked: PropTypes.bool.isRequired,

  /**
   * Callback function to handle click actions.
   */
  onChange: PropTypes.func,
};
